export const SET_SEARCH_KEYWORD = "SET_SEARCH_KEYWORD";

export const setSearchKeyword = (keyword) => {
	return { type: SET_SEARCH_KEYWORD, keyword };
};
